const CLIENT_NAME_KEY = 'Trimble-FieldSystems-ClientName';
const CLIENT_VERSION_KEY = 'Trimble-FieldSystems-ClientVersion';

export type ImagingDataHeaders = {
  [CLIENT_NAME_KEY]: string;
  [CLIENT_VERSION_KEY]: string;
};

export function getDefaultImagingHeaders(
  clientName: string,
  clientVersion: string
): ImagingDataHeaders {
  return {
    [CLIENT_NAME_KEY]: clientName,
    [CLIENT_VERSION_KEY]: clientVersion,
  };
}
